import { currencyInput } from '@/_schemas/generic';

import {
  campaignTypeQueryToFormConverter,
  type MarketingCampaignFormSchema,
  type MarketingCampaignQuerySchema,
} from '../schemas';

export function marketingCampaignQueryToForm(data: MarketingCampaignQuerySchema): MarketingCampaignFormSchema {
  return {
    ...data,
    date: data.date ?? '',
    name: data.name ?? '',
    notes: data.notes ?? '',
    campaign_type: campaignTypeQueryToFormConverter(data?.campaign_type),
    total_cost_of_campaign: currencyInput.queryToFormConverter(data.total_cost_of_campaign),
    attached_files: data.attached_files ?? [],
  };
}
